/**
 * Supcase Header Desktop Navigation - Scroll Buttons
 * Handles overflow detection and smooth scrolling for navigation menus
 * when menu items exceed available width (viewport 1024px - 1799px).
 */
(function() {
  'use strict';

  /**
   * Initialize scroll behavior for a single nav group (prev btn + ul + next btn)
   */
  function initScrollGroup(prevBtn, nextBtn, navList) {
    if (!prevBtn || !nextBtn || !navList) return;

    function checkOverflow() {
      // Allow 1px tolerance for subpixel rendering
      var isOverflowing = navList.scrollWidth > navList.clientWidth + 1;

      if (isOverflowing) {
        prevBtn.classList.remove('site-nav__scroll-btn--hidden');
        nextBtn.classList.remove('site-nav__scroll-btn--hidden');
        updateButtonState();
      } else {
        prevBtn.classList.add('site-nav__scroll-btn--hidden');
        nextBtn.classList.add('site-nav__scroll-btn--hidden');
        // Reset scroll position when no overflow
        navList.scrollLeft = 0;
      }
    }

    function updateButtonState() {
      // Disable prev button when at start
      if (navList.scrollLeft <= 1) {
        prevBtn.classList.add('site-nav__scroll-btn--disabled');
      } else {
        prevBtn.classList.remove('site-nav__scroll-btn--disabled');
      }

      // Disable next button when at end (1px tolerance)
      var maxScroll = navList.scrollWidth - navList.clientWidth;
      if (navList.scrollLeft >= maxScroll - 1) {
        nextBtn.classList.add('site-nav__scroll-btn--disabled');
      } else {
        nextBtn.classList.remove('site-nav__scroll-btn--disabled');
      }
    }

    function scroll(direction) {
      var scrollAmount = navList.clientWidth * 0.5; // Scroll 50% of visible width per click
      if (scrollAmount < 100) scrollAmount = 100; // Minimum scroll amount

      var target;
      if (direction === 'prev') {
        target = Math.max(0, navList.scrollLeft - scrollAmount);
      } else {
        target = Math.min(
          navList.scrollWidth - navList.clientWidth,
          navList.scrollLeft + scrollAmount
        );
      }

      navList.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    }

    // Click handlers
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      scroll('prev');
    });

    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      scroll('next');
    });

    // Update button state on scroll
    navList.addEventListener('scroll', function() {
      updateButtonState();
    });

    // Initial check
    checkOverflow();

    // Re-check on window resize (debounced)
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        checkOverflow();
      }, 150);
    });

    // Re-check when mega menu toggles (may change layout)
    if (window.MutationObserver) {
      var observer = new MutationObserver(function() {
        checkOverflow();
      });
      observer.observe(navList, { childList: true, subtree: true, attributes: true });
    }
  }

  /**
   * Find and initialize all scroll groups in the page
   */
  function initAllScrollGroups() {
    // Select all containers that may have scroll buttons
    var containers = document.querySelectorAll(
      '.header-item--navigation, .header-layout--center .text-center, .header-item--split-left, .header-item--split-right'
    );

    containers.forEach(function(container) {
      var prevBtn = container.querySelector('.site-nav__scroll-btn--prev');
      var nextBtn = container.querySelector('.site-nav__scroll-btn--next');
      var navList = container.querySelector('.site-navigation');

      if (prevBtn && nextBtn && navList) {
        initScrollGroup(prevBtn, nextBtn, navList);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllScrollGroups);
  } else {
    initAllScrollGroups();
  }

  // Re-initialize after Shopify theme editor section updates
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initAllScrollGroups();
    });
  }
})();
